import React from 'react';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TooltipRenderProps } from 'react-joyride';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import SZLogoIcon from 'buyside/svgs/logo_white.svg';

import styles from './szJoyrideStyles.scss';

const SZJoyrideTooltip: React.FC<TooltipRenderProps> = ({
  backProps,
  closeProps,
  continuous,
  index,
  primaryProps,
  size,
  skipProps,
  step,
  tooltipProps
}) => {
  const isFinalStep = index + 1 === size;

  return (
    <div {...tooltipProps} className={styles.tooltip}>
      <div className={styles.header}>
        {step.title ? (
          <p>
            <SZLogoIcon className={styles.logo} />
            {step.title}
          </p>
        ) : null}
        <button {...closeProps}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
      <div>{step.content}</div>
      <div className={styles.footer}>
        <Button
          {...skipProps}
          size={BUTTON_SIZES.SMALL}
          text={continuous ? 'Skip Walkthrough' : "Don't show again"}
          type={BUTTON_TYPES.LINK}
        />
        {continuous ? (
          <>
            {index > 0 ? (
              <Button
                {...backProps}
                size={BUTTON_SIZES.SMALL}
                text="Back"
                type={BUTTON_TYPES.SECONDARY}
              />
            ) : null}
            <Button
              {...(isFinalStep ? skipProps : primaryProps)}
              size={BUTTON_SIZES.SMALL}
              text={`${isFinalStep ? 'Done' : 'Next'} ( ${index + 1} / ${size} )`}
              type={BUTTON_TYPES.MAJOR}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default SZJoyrideTooltip;
